import i18n from "../../services/localization-service/i18n";
import { AccessType } from "../enums/DRCXEnums";

export function getAccessText(access: AccessType) {
    return access === AccessType.Private
        ? i18n.t("configuration.accessLevels.private")
        : access === AccessType.Shared
            ? i18n.t("configuration.accessLevels.shared")
            : i18n.t("configuration.accessLevels.sharedReadOnly");
}
